import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/header';
import Footer from './components/footer';
import TrustStrip from './components/truststrip';
import SaferGamblingBanner from './components/safergamblingbanner';
import CookieBanner from './components/cookiebanner';
import FilterGate from './components/filtergate';
import Home from './pages/home';
import WelcomeBonuses from './pages/welcomebonuses';
import NewCasinoSites from './pages/newcasinos';
import HowItWorks from './pages/howitworks';
import ResponsibleGambling from './pages/responsiblegambling';
import './styles/global.css';

export default function App() {
  return (
    <HelmetProvider>
      <FilterGate>
        <Router>
          <CookieBanner />
          <div className="page-wrapper">
            <Header />
            <TrustStrip />
            <SaferGamblingBanner />
            <main className="page-content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/welcome-bonuses" element={<WelcomeBonuses />} />
                <Route path="/new-casino-sites" element={<NewCasinoSites />} />
                <Route path="/how-it-works" element={<HowItWorks />} />
                <Route path="/responsible-gambling" element={<ResponsibleGambling />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </FilterGate>
    </HelmetProvider>
  );
}
